import React from 'react';
import LoadingSpinner from 'components/LoadingSpinner';
import {
  FormValues,
  Product
} from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import ProductCostSection from '../../../FillProductDetailsDrawer/components/ProductCostSection';
import ProductOtherSection from '../../../FillProductDetailsDrawer/components/ProductOtherSection';

interface CarrierDetailsStepProps {
  carrier: Product;
  isLoading: boolean;
  application?: FormValues;
}
const CarrierDetailsStep: React.FC<CarrierDetailsStepProps> = ({
  carrier,
  isLoading,
  application
}) => {
  if (isLoading)
    return (
      <div className="pt-128px">
        <LoadingSpinner />
      </div>
    );

  if (!carrier) return null;

  return (
    <div className="px-8">
      <div className="cwf-product-drawer-form-content">
        <ProductCostSection product={carrier} application={application} />
        <ProductOtherSection />
      </div>
    </div>
  );
};

export default CarrierDetailsStep;
